import {StorageKeys} from '../../shared/models/storage-keys';
import {ReplaySubject, Subject} from 'rxjs';
import {ConfigsModel} from '../../shared/models/configs.model';
import {LocalStorageService} from './local-storage.service';
import {AppConfig} from '../../shared/config/app-config';
import {ApiClientHelper} from '../helpers/api-client.helper';
import {Injectable} from '@angular/core';
import {StringHelper} from '../helpers/strings.helper';

@Injectable({
	providedIn: 'root'
})
export class ConfigService {

	configObj: Subject<ConfigsModel> = new ReplaySubject();
	usedPlatforms: Subject<{ name }[]> = new ReplaySubject();
	private configurations: ConfigsModel;

	constructor(
		private apiClientHelper: ApiClientHelper,
		public config: AppConfig,
		private localStorage: LocalStorageService,
	) {
		this.initialize();
	}

	initialize() {
		this.initializeConfigurations();
		this.initializeUsedPlatforms();
	}

	getSavedConfig() {
		const config = this.localStorage.get(StorageKeys.config);
		if (StringHelper.isNullOrEmptyOrUndefined(config)) {
			return null;
		}
		return JSON.parse(config);
	}

	saveConfig(config) {
		if (StringHelper.isNullOrEmptyOrUndefined(config)) {
			this.localStorage.deleteValue(StorageKeys.config);
			return;
		}
		this.localStorage.save(StorageKeys.config, JSON.stringify(config));
	}

	initializeConfigurations() {
		const savedConfig = this.getSavedConfig();
		if (!StringHelper.isNullOrEmptyOrUndefined(savedConfig)) {
			this.setConfig(savedConfig);
			return;
		}
		this.setConfigV2();
	}

	setConfigV2() {
		this.getConfig().then(res => {
			this.setConfig(res);
		}).catch(err => {
			this.configObj.next(null);
		});
	}

	setConfig(res) {
		this.configObj.next(res);
		this.setConfiguration(res);
		this.saveConfig(res);
	}

	initializeUsedPlatforms() {
		const token = this.localStorage.get(StorageKeys.token);
		if (!token) {
			return;
		}
		this.getUsedPlatforms().then(res => {
			this.usedPlatforms.next(res);
		});
	}

	setConfiguration(config: ConfigsModel) {
		this.configurations = config;
	}

	getConfiguration() {
		return this.configurations;
	}

	getConfig(): Promise<ConfigsModel> {
		const url = this.config.MONIEPOINT_HOST + `/api/v1/configurations`;
		return this.apiClientHelper.getForPromise(url);
	}

	getUsedPlatforms(): Promise<{ name }[]> {
		const url = this.config.MONIEPOINT_HOST + `/api/v1/agents-location/used-platforms`;
		return this.apiClientHelper.getForPromise(url);
	}
}
